<template>
  <div class="register-container" :class="{ 'is-embedded': embedded }">
    <div class="register-card">
      <div class="register-title">用户注册</div>
      <el-form
        ref="registerForm"
        :model="registerForm"
        :rules="registerRules"
        class="register-form"
      >
        <!-- 手机号输入 -->
        <el-form-item prop="username">
          <div v-if="embedded" class="embedded-field-label"><span class="form-label-required">*</span>手机号</div>
          <div class="input-wrapper">
            <img
              src="@/assets/image/sjh1.png"
              class="input-icon"
              alt="手机图标"
            >
            <el-input
              v-model="registerForm.username"
              placeholder="请输入手机号"
              name="username"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </div>
        </el-form-item>

        <!-- 密码输入 -->
        <el-form-item prop="password">
          <div v-if="embedded" class="embedded-field-label"><span class="form-label-required">*</span>密码</div>
          <div class="input-wrapper">
            <img
              src="@/assets/image/psw1.png"
              class="input-icon"
              alt="密码图标"
            >
            <el-input
              :key="passwordType"
              ref="password"
              v-model="registerForm.password"
              :type="passwordType"
              placeholder="请输入密码"
              name="password"
              tabindex="2"
              auto-complete="off"
            />
            <span
              class="show-pwd"
              @click="showPwd"
            >
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </div>
        </el-form-item>

        <!-- 图形验证码 -->
        <el-form-item prop="captcha">
          <div v-if="embedded" class="embedded-field-label"><span class="form-label-required">*</span>图形验证码</div>
          <div class="input-wrapper captcha-row">
            <el-input
              v-model="registerForm.captcha"
              placeholder="请输入图形验证码"
              name="captcha"
              type="text"
              auto-complete="off"
              class="captcha-input"
              @keyup.enter.native="handleRegister"
            />
            <img
              class="captcha-img"
              :src="captchaUrl"
              alt="图形验证码"
              @click="refreshCaptcha"
            >
          </div>
        </el-form-item>

        <div v-if="embedded && formError" class="inline-form-error">{{ formError }}</div>
        <register-agreement ref="registerAgreement" />
        <!-- 注册按钮 -->
        <el-button
          :loading="loading"
          type="primary"
          class="register-btn"
          @click.native.prevent="handleRegister"
        >
          注册
        </el-button>
      </el-form>

      <!-- 返回登录 -->
      <div class="footer-links">
        <span class="link-item" @click="goToLogin">已有账号？去登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { registerUser } from '@/api/user'
import RegisterAgreement from '@/components/RegisterAgreement.vue'

export default {
  name: 'UserRegister',
  components: { RegisterAgreement },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (!value || value.trim() === '') callback(new Error('请输入图形验证码'))
      else callback()
    }
    return {
      registerForm: {
        username: '',
        password: '',
        captcha: ''
      },
      registerRules: {
        username: [{ required: true, trigger: 'blur', validator: validatePhone }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCaptcha }]
      },
      loading: false,
      passwordType: 'password',
      captchaUrl: '',
      captchaObjectUrl: '', // deprecated
      formError: ''
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      const t = Date.now()
      this.captchaUrl = `/api/user/captcha?t=${t}`
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleRegister() {
      if (this.$refs.registerAgreement && !this.$refs.registerAgreement.validate()) {
        return
      }
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          if (this.embedded) this.formError = ''
          this.loading = true
          const data = {
            username: this.registerForm.username,
            password: this.registerForm.password,
            captcha: this.registerForm.captcha
          }
          const silentOpt = this.embedded ? { silentError: true } : {}
          registerUser(data, silentOpt).then(response => {
            this.loading = false
            if (response && response.code === 1) {
              this.$message.success('注册成功')
              if (this.embedded) {
                this.$emit('registered')
              } else {
                setTimeout(() => {
                  this.$router.push('/login')
                }, 1500)
              }
            } else {
              const msg = response?.msg || '注册失败'
              if (this.embedded) this.formError = msg
              else this.$message.error(msg)
            }
          }).catch(error => {
            this.loading = false
            console.error('注册失败:', error)
            if (this.embedded) {
              this.formError = (error && error.message) || '注册失败，请重试'
            } else {
              this.$message.error('注册失败，请重试')
            }
            this.refreshCaptcha()
          })
        } else {
          return false
        }
      })
    },
    goToLogin() {
      if (this.embedded) {
        this.$emit('switch-login')
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg1.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
  overflow: hidden;

  &.is-embedded {
    min-height: auto;
    background: none;
    display: block;
    overflow: visible;
    padding: 0;
  }
}

.register-container.is-embedded .register-card {
  margin-right: 0;
  width: 100%;
  max-width: none;
  box-shadow: none;
  background: transparent;
  padding: 0;
  border: none;
}

.register-container.is-embedded .register-title {
  margin-bottom: 16px;
  font-size: 18px;
}

.register-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  width: 480px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 10%;

  .register-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 30px;
  }

  .register-form {
    .embedded-field-label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }

    .form-label-required {
      color: #f56c6c;
      margin-right: 2px;
      font-weight: 600;
    }

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 0 15px;
      background: #fff;
      transition: all 0.3s ease;

      &:focus-within {
        border-color: #4a90e2;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
      }

      .input-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        flex-shrink: 0;
      }

      .el-input {
        flex: 1;

        ::v-deep .el-input__inner {
          border: none;
          background: transparent;
          padding: 15px 0;
          font-size: 14px;
          color: #333;

          &::placeholder {
            color: #999;
          }
        }
      }

      .show-pwd {
        cursor: pointer;
        color: #999;
        margin-left: 10px;
        padding: 5px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          color: #4a90e2;
          background: rgba(74, 144, 226, 0.1);
        }
      }
    }

    .inline-form-error {
      margin-bottom: 10px;
      font-size: 13px;
      line-height: 1.45;
      color: #f56c6c;
      text-align: left;
    }

    .register-btn {
      width: 100%;
      height: 48px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(90deg, #0f6fe2, #0c89f2);
      border: none;
      margin-top: 20px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
      }
    }

    .captcha-row {
      gap: 12px;
    }

    .captcha-input {
      flex: 1;
    }

    .captcha-img {
      width: 96px;
      height: 34px;
      border-radius: 6px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      object-fit: cover;
      flex-shrink: 0;
    }
  }

  .footer-links {
    text-align: center;
    margin-top: 20px;

    .link-item {
      color: #0f6fe2;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s ease;

      &:hover {
        color: #0c89f2;
        text-decoration: underline;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .register-card {
    width: 380px;
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .register-container {
    padding: 20px;
  }

  .register-card {
    width: 100%;
    max-width: 400px;
    padding: 25px;
  }
}
</style>

